import { setTerm } from './helpers';

export const setDemolition = setTerm('demolished_in_moscow_programm');
